module.exports = __webpack_public_path__ + "img/c2.6533cf99.jpg";